<template>
  <div>
    <NavbarBaseNav v-model:show="showMenu" class="navbar-absolute top-navbar" type="white" :transparent="true"
      style="width: 100px; position: fixed; left: 15px;">
      <template #brand>
        <div class="navbar-wrapper">
          <div class="navbar-minimize d-inline">
            <LayoutSidebarToggleButton />
          </div>
          <div class="navbar-toggle d-inline" :class="{ toggled: $sidebar.showSidebar }">
            <button type="button" class="navbar-toggler" @click="toggleSidebar">
              <span class="navbar-toggler-bar bar1"></span>
              <span class="navbar-toggler-bar bar2"></span>
              <span class="navbar-toggler-bar bar3"></span>
            </button>
          </div>
        </div>
      </template>

      <!--    <ul class="navbar-nav ml-auto">
            <account-icon></account-icon>
          </ul>-->
    </NavbarBaseNav>

    <NavbarBaseNav v-model:show="showMenu" class="d-none d-lg-block navbar-absolute top-navbar" type="white"
      :transparent="true" style="width: 100px; position: fixed; right: 8px; top: -3px">
      <ul class="navbar-nav ml-auto">
        <AccountIcon with-help-link></AccountIcon>
      </ul>
    </NavbarBaseNav>
  </div>
</template>
<script lang="ts" setup>
import {useSidebar} from "~/modules/common/stores/sidebar";
import {storeToRefs} from "pinia";

const $sidebar = useSidebar();



const route = useRoute();

const activeNotifications = ref(false);
const showMenu = ref(false);
const searchModalVisible = ref(false);
const searchQuery = ref('');

const capitalizeFirstLetter = (value: string) => {
  if (!value) {
    return ''
  }
  return value.charAt(0).toUpperCase() + value.slice(1);
};

const closeDropDown = () => {
  activeNotifications.value = false;
};

const toggleSidebar = () => {
  $sidebar.displaySidebar(!$sidebar.showSidebar);
};

const toggleMenu = () => {
  showMenu.value = !showMenu.value;
};

const routeName = computed(() => {
  const { path } = route;
  let parts: string[] = path.split('/');
  return parts.join(' ');
});
</script>
<style scoped>
.top-navbar {
  top: 0;
}

@media (max-width: 1199px) {

  .navbar-toggle {
    position: absolute;
    top: 14px;
    left: -12px;
  }
}
</style>
